import React from 'react';
import { Row, Col } from 'antd';
import { Typography } from 'antd';

const { Text, Link } = Typography;


function Access(props) {
    return (
        <Row>
            <Col xs={1} xl={4}>

            </Col>
            <Col xs={22} xl={16}>

                <h1>Accessing the Compass API</h1>

                <p>In this section, we will describe how to access the API. The API uses a token authentication flow.</p>

                <p>To start you will need to request an access token from your customer contact. We recommend you keep this access token private. </p>

                <p>Once you have your access token the flow is as follows. </p>

                <div className="image">
                    <img src="/token_access.png" alt="image" />
                </div>

                <p>Looking in more detail at each of those stages</p>

                <p>1.The client application POSTS request to the /accesscheck endpoint including the access_token in JSON body of the request.
                CURL example below</p>

                <pre><code>curl -X POST "https://api.sabinet-arq.com/users/accesscheck" -H "Content-Type: application/json" -d '&#123;"access_token":"b62bc52ba2bfa5017926962b"&#125;'</code></pre>


                <p>2. Once verified, the API will create a JSON Web Token IDToken which will last for a maximum of 60 minutes. The the API will return that token back to the client application.</p>

                <p>This response will look similar to this</p>

                <pre><code>
                &#123;
                "status":"success",
                "data":&#123;
                    "label":"LucalliInstitution2",
                    "IdToken":"eyJraWQiOiJUTjRFYUJGUzRMREpjZGVmQ081ViszTHhod0MwY0ViRTBYRXZMU2ZzZG1jPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI4OWM5NTUwMC04ZTU0LTQxNGUtOGU5Yy1hMjYyZGJlNWQxNWQiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtd2VzdC0xLmFtYXpvbmF3cy5jb21cL2V1LXdlc3QtMV9ZWm9ZWnRqcGQiLCJjb2duaXRvOnVzZXJuYW1lIjoiTHVjYWxsaUluc3RpdHV0aW9uMiIsIm9yaWdpbl9qdGkiOiIwZGZhMDAwOS1hMTdhLTQ0NmItYThhYi1iYjQ3YzA3NDEyOWUiLCJhdWQiOiIxMjAxamU4NW9zdjl1cGFzZTExaGc0b3RsMSIsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNjU2NjY4MDg5LCJuYW1lIjoiTHVjYWxsaUluc3RpdHV0aW9uMiIsImV4cCI6MTY1NjY3MTY4OSwiY3VzdG9tOnJvbGUiOiJJbnN0aXR1dGlvbiIsImlhdCI6MTY1NjY2ODA4OSwianRpIjoiOTZjNTllNjAtM2I1Ni00ZTE0LThhNmItMzg2ZDI0ZDQ2ODRlIn0.AbEfsikBnRcNA49C2MJr7LHB0iEw8ag6Aa5DnQSmEK5OtqOMl2R8B1aDM4Dh5FFDaGjau1gzX2wBpI23cMYvOS8Ezz-V43tQa7bDJZfY-SNpH2pZaWIgNPOqYk7V4iNAX4J-O19pZ3NvUR10zjpRmOP7MiHlGvsdl61v4tchClnsJKeLEehlk_eHgUlM22hqBUZzEYjHqqejQeJgQBcp2RGHbKfcN3abVm_hhsAgGRX-tP4pIbhutRvhgyKscDN9ThzqYNLXe9Vw6xX5jpPwd9-nQghRavuu-mDsoCkU_zrcVBJvfHbdQmQzun-oXme4HQC6dKp5lahZjv62ORHEtg"
                &#125;
                &#125;
                </code></pre>

                <p>3. The client app will receive the IdToken from the response, and then proceed to use it as an Authorization header on every subsequent request to the other API endpoints. </p>

                <p>An example request including the Authorization header would look like</p>

                <p>Please note all requests must have a Content-Type: application/json header</p>

                <pre><code>curl -X POST "https://api.sabinet-arq.com/search/resourcespublic" -H "Content-Type: application/json" -d '&#123;"query":&#123;"bool":&#123;"must":[&#123;"match":&#123;"title":"test"&#125;&#125;],"must_not":[],"should":[]&#125;&#125;,"from":0,"size":10,"sort":[]&#125;' -H "Authorization: ID TOKEN FROM LAST REQUEST"</code></pre>

                <p>If the token is active and verified the API will respond with the results based on the endpoint as documented in the ReDoc section.</p>

                <p>Please note that the API can have client-specific restrictions on the number of requests made if you go passed these then you will no longer be able to call the API until that time period has passed(normally 1 hour)</p>


            </Col>
            <Col xs={1} xl={4}>

            </Col>
        </Row>
    )
}
export default Access;